import { callFunction } from "./functions-client";

// Server-computed KPI summary for a profile (LOS Phase 15). The per-row charts stay
// in the pure, dependency-free ./analytics helpers; this is the DB rollup.
export interface AnalyticsSummary {
  jobs: { posted: number; open: number };
  applications: { received: number; hires: number; hire_rate: number; sent: number };
  loads: { posted: number; awarded: number };
  bids: { placed: number; won: number; win_rate: number };
  activity_30d: number;
}

export const getAnalyticsSummary = (profileId: string) =>
  callFunction<AnalyticsSummary>(`analytics/summary?profile_id=${encodeURIComponent(profileId)}`, { method: "GET" });
